module.exports = __webpack_public_path__ + "static/typewritter-aaa87258a03313f9989cb54c28ddf344.svg";